var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppSelect',{staticClass:"my-4",attrs:{"label":"モデル","width":"240px","items":_vm.claudeChoice},model:{value:(_vm.value.model),callback:function ($$v) {_vm.$set(_vm.value, "model", $$v)},expression:"value.model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }